import Vue from 'vue'
import VueRouter from 'vue-router'
import { scrollBehavior } from './util/scroll-behavior'
import Home from './components/Home.vue'

Vue.use(VueRouter)

function PageTitle (title) {
  return {
    render (h) {
      return <h1 class="text-gray-600 text-xl">
        {title}
      </h1>
    },
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: () => import(
      /* webpackChunkName: "SignIn.vue" */
      './components/user/SignIn.vue'
    ),
  },
  {
    path: '/dashboard',
    component: () => import(
      /* webpackChunkName: "Dashboard.vue" */
      './components/user/Dashboard.vue'
    ),
    children: [
      {
        path: '',
        name: 'dashboard',
        components: {
          default: () => import(
            /* webpackChunkName: "StatusList.vue" */
            './components/status/StatusList.vue'
          ),
          header: () => import(
            /* webpackChunkName: "DashboardHeader.vue" */
            './components/user/DashboardHeader.vue'
          ),
        },
      },
      {
        path: 'account',
        name: 'account',
        components: {
          default: () => import(
            /* webpackChunkName: "Account.vue" */
            './components/user/Account.vue'
          ),
          header: PageTitle('Your Account'),
        },
      },
      {
        path: 'linked-accounts',
        name: 'linked-accounts',
        components: {
          default: () => import(
            /* webpackChunkName: "LinkedAccounts.vue" */
            './components/user/LinkedAccounts.vue'
          ),
          header: PageTitle('Linked accounts'),
        },
      },
      {
        path: 'add-account',
        name: 'add-account',
        components: {
          default: () => import(
            /* webpackChunkName: "AddAccount.vue" */
            './components/user/AddAccount.vue'
          ),
          header: PageTitle('Add an account'),
        },
      },
      {
        path: 'billing',
        name: 'billing',
        components: {
          default: () => import(
            /* webpackChunkName: "BillingPage.vue" */
            './components/billing/BillingPage.vue'
          ),
          header: PageTitle('Billing'),
        },
      },
      {
        path: '/help',
        name: 'help',
        components: {
          default: () => import(
            /* webpackChunkName: "Help.vue" */
            './components/Help.vue'
          ),
          header: PageTitle('Help & Feedback'),
        },
      },
      {
        path: '/faq',
        name: 'faq',
        components: {
          default: () => import(
            /* webpackChunkName: "Faq.vue" */
            './components/Faq.vue'
          ),
          header: PageTitle('FAQ'),
        },
      },
      {
        path: '/about',
        name: 'about',
        components: {
          default: () => import(
            /* webpackChunkName: "About.vue" */
            './components/About.vue'
          ),
          header: PageTitle('About'),
        },
      },
    ],
  },
  {
    path: '/status/add',
    name: 'add-status',
    component: () => import(
      /* webpackChunkName: "StatusAdd.vue" */
      './components/status/StatusAdd.vue'
    ),
    props: true,
  },
  {
    path: '/status/quick',
    name: 'quick-status',
    component: () => import(
      /* webpackChunkName: "QuickStatus.vue" */
      './components/status/QuickStatus.vue'
    ),
  },
  {
    path: '/status/:statusId/edit',
    name: 'edit-status',
    component: () => import(
      /* webpackChunkName: "StatusEdit.vue" */
      './components/status/StatusEdit.vue'
    ),
    props: true,
  },
  {
    path: '/status/:statusId/send',
    name: 'send-status',
    component: () => import(
      /* webpackChunkName: "StatusSend.vue" */
      './components/status/StatusSend.vue'
    ),
    props: true,
  },
  {
    path: '/status/:statusId/send/progress',
    name: 'send-status-progress',
    component: () => import(
      /* webpackChunkName: "StatusSendProgress.vue" */
      './components/status/StatusSendProgress.vue'
    ),
    props: route => ({
      statusId: route.params.statusId,
      accountIds: JSON.parse(route.query.accountIds || 'null'),
    }),
  },
  {
    path: '/tos',
    name: 'tos',
    component: () => import(
      /* webpackChunkName: "ToS.vue" */
      './components/ToS.vue'
    ),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(
      /* webpackChunkName: "Privacy.vue" */
      './components/Privacy.vue'
    ),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import(
      /* webpackChunkName: "DemoPage.vue" */
      './components/DemoPage.vue'
    ),
  },
  {
    path: '*',
    redirect: { name: 'home' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
})

export default router
